<template>
  <b-overlay :show="isLoading" rounded="sm">
  <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <dl class="row mb-0 font-size-14">
            <dt class="col-sm-4">ID</dt>
            <dd class="col-sm-8">: {{data.partida_id}}</dd>
          </dl>
        </div>
      </div>
      <div class="row">
        <button type="button" class="btn btn-primary m-2" v-on:click="abrirCarga">Cargar fotos</button>
      </div>

      <b-modal
          id="modalUpload"
          scrollable
          title="Subir archivo"
          title-class="font-18"
          size="lg"
          no-close-on-esc
          hide-footer
          centered
      >
        <subirArchivos v-on:upload-complete="uploadComplete" />
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
    import subirArchivos from "@/components/subir-archivos";
    export default {
        name: "cuaderno-obra",
        components: {
          subirArchivos,
        },
        methods:{
          uploadComplete(files){
            this.isLoading=true;
            this.axios.post(process.env.VUE_APP_BACKEND + "/api/cuaderno-obra/archivos",
                {
                  files:files,
                  expediente_id:this.data.expediente_id,
                  fecha:this.data.fecha
                })
                .then(()=>{
                  this.$bvModal.hide("modalUpload");
                  this.actualizar();
                })
                .finally(()=>this.isLoading=false)

          },
          abrirCarga(){
            this.$bvModal.show("modalUpload");
          },
          actualizar(){
            this.isLoading=true;
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/cuaderno-obra/archivos",
                {
                  'params':{
                    'expediente_id':this.data.expediente_id,
                    'fecha':this.data.fecha
                  }
                }
            )
            .then((response)=>{
              this.model=response.data;
              console.log(response);
            })
            .finally(()=>this.isLoading=false)

          },
          borrarArchivo(id){
            this.$swal.fire({
              title: '¿Esta seguro de eliminar esta foto?',
              text: "",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Si, borralo!'
            }).then((result) => {
              if (result.value) {
                this.isLoading=true;
                this.axios.delete(process.env.VUE_APP_BACKEND +'/api/cuaderno-obra/'+this.model.id+'/archivos/'+id)
                  .catch(()=>{
                    this.$swal('error','Error eliminando','error');
                  })
                  .finally(
                      ()=>
                      {
                        this.isLoading=false;
                        this.actualizar();
                      }
                  );
              }
            })
          }
        },
        props: {
            data:{
                type:Object
            }
        },
        data() {
            return {
                server:process.env.VUE_APP_BACKEND,
                isLoading:false,
                model:{}
            }
        },
        mounted() {
         this.actualizar();
        }
    }
</script>

<style scoped>

</style>